import React from "react"
import { Navbar, Image } from 'react-bootstrap'
import { getParams, end_point, applyOrganizationTheme, getStoredOrganizationTheme } from './helper'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faBars, faTimes, faChevronLeft } from '@fortawesome/free-solid-svg-icons'
var $ = require('jquery')

class HamburgerNavbar extends React.Component {
  constructor(props) {
    super(props);
    const storedTheme = getStoredOrganizationTheme() || {}
    const storedToken = typeof window !== 'undefined' ? localStorage.getItem('jwt') : ''
    const storedLogo = typeof window !== 'undefined' ? localStorage.getItem('organization_logo') : ''
    this.state = {
      token: storedToken || getParams().jwt || this.props.token,
      name: localStorage.getItem('organization_name') || '',
      logo: storedLogo || '/logoREPLACE.png',
      navbarColor: storedTheme.navbar_color || '#5563b8',
      navbarTextColor: storedTheme.navbar_text_color || '#ffffff',
      organization_endpoint: `${end_point('organizations')}/organizations`,
      user_endpoint: `${end_point('users')}/users`,
      organization_id: this.props.organization_id? this.props.organization_id: localStorage.getItem("organization_id"),
      // Keep navigation unavailable until the authenticated user's role is known.
      // An empty role must never fall through to the admin navigation.
      type: null,
      league: this.props.league,
      menuOpen: false,
      logoMenuOpen: false,
      viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1024,
    };
    this.menuRef = React.createRef()
    this.logoMenuRef = React.createRef()
    this.logoMenuCloseTimer = null
  }

  componentDidMount() {
    if(!localStorage.getItem('organization_id') && this.props.organization_id){
      localStorage.setItem('organization_id', this.props.organization_id)
    }

    console.log('HamburgerNavbar cDM what is org? =', this.state.organization_id)
    $.ajax({
        headers: {
            "token": this.state.token,
            "organization_id": this.state.organization_id,
            "league": this.state.league
        },
        method: "GET",
        dataType: "json",
        url: this.state.organization_endpoint,
    }).then(org => {
      console.log("org from navbar", org)
      const organization = org && org.message && !org.name ? org.message : org
      if (organization && organization.name) {
        localStorage.setItem('organization_name', organization.name)
      }
      this.hamburgerGetHandler(organization || {})
    });
    $.ajax({
        headers: {
            "token": this.state.token,
            "organization_id": this.state.organization_id,
            "current_user_needed": "true"
        },
        method: "GET",
        dataType: "json",
        url: this.state.user_endpoint,
    }).then(user => {
      const currentUser = user && user.message && user.message[0]
      console.log('user from hamburg navbar', currentUser)
      this.setState({ type: currentUser && currentUser.type ? currentUser.type : null })
    });
    document.addEventListener('mousedown', this.handleDocumentClick)
    document.addEventListener('keydown', this.handleDocumentKeydown)
    window.addEventListener('resize', this.handleWindowResize)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentClick)
    document.removeEventListener('keydown', this.handleDocumentKeydown)
    window.removeEventListener('resize', this.handleWindowResize)
    if (this.logoMenuCloseTimer) {
      clearTimeout(this.logoMenuCloseTimer)
    }
  }
    
  hamburgerGetHandler = (resp) => {
    const logo = resp.logo || resp.logo_url || resp.organization_logo || ''
    if (logo) {
      localStorage.setItem('organization_logo', logo)
    }
    this.setState({
      name: resp.name || localStorage.getItem('organization_name') || '',
      logo: logo || this.state.logo || '/logoREPLACE.png',
      navbarColor: resp.navbar_color || '#5563b8',
      navbarTextColor: resp.navbar_text_color || '#ffffff'
    });
    applyOrganizationTheme({
      navbar_color: resp.navbar_color || '#5563b8',
      navbar_text_color: resp.navbar_text_color || '#ffffff'
    })
  }

  handleDocumentClick = (event) => {
    if (this.state.menuOpen && this.menuRef.current && !this.menuRef.current.contains(event.target)) {
      this.setState({ menuOpen: false })
    }
    if (this.state.logoMenuOpen && this.logoMenuRef.current && !this.logoMenuRef.current.contains(event.target)) {
      this.setState({ logoMenuOpen: false })
    }
  }

  handleDocumentKeydown = (event) => {
    if (event.key === 'Escape') {
      if (this.state.menuOpen) {
        this.setState({ menuOpen: false })
      }
      if (this.state.logoMenuOpen) {
        this.setState({ logoMenuOpen: false })
      }
    }
  }

  handleWindowResize = () => {
    this.setState({ viewportWidth: window.innerWidth })
  }

  toggleMenu = () => {
    this.setState((prevState) => ({ menuOpen: !prevState.menuOpen }))
  }

  closeMenu = () => {
    this.setState({ menuOpen: false })
  }

  toggleLogoMenu = () => {
    this.setState((prevState) => ({ logoMenuOpen: !prevState.logoMenuOpen }))
  }

  closeLogoMenu = () => {
    if (this.logoMenuCloseTimer) {
      clearTimeout(this.logoMenuCloseTimer)
      this.logoMenuCloseTimer = null
    }
    this.setState({ logoMenuOpen: false })
  }

  openLogoMenu = () => {
    if (this.logoMenuCloseTimer) {
      clearTimeout(this.logoMenuCloseTimer)
      this.logoMenuCloseTimer = null
    }
    this.setState({ logoMenuOpen: true })
  }

  scheduleCloseLogoMenu = () => {
    if (this.logoMenuCloseTimer) {
      clearTimeout(this.logoMenuCloseTimer)
    }
    this.logoMenuCloseTimer = setTimeout(() => {
      this.setState({ logoMenuOpen: false })
      this.logoMenuCloseTimer = null
    }, 280)
  }

  buildDesktopTabs = (currentPath = '') => {
    const { token, type } = this.state
    const origin = document.location.origin
    const currentUrl = typeof window !== 'undefined' ? window.location.href : origin
    const organizationId = this.state.organization_id || localStorage.getItem('organization_id') || ''
    const organizationName = encodeURIComponent(
      this.state.name || localStorage.getItem('organization_name') || ''
    )
    const registrationHref = currentPath.includes('/enrollment')
      ? currentUrl
      : `${origin}/enrollmentform?jwt=${token}&organization_id=${organizationId}&organization_name=${organizationName}`

    if (type === 'parent') {
      return [
        { label: 'Registration', href: registrationHref, match: ['/enrollment', '/enrollmentform', '/enrollment-test'] },
        { label: 'Parent Portal', href: `${origin}/portals?jwt=${token}&portalMode=parent`, match: ['/portals'] },
      ]
    }

    return [
      { label: 'Dashboard', href: `${origin}/portals?jwt=${token}`, match: ['/portals'] },
      { label: 'Programs', href: `${origin}/programs2?jwt=${token}`, match: ['/programs2'] },
      { label: 'Rosters', href: `${origin}/programRosters?jwt=${token}`, match: ['/programRosters'] },
      { label: 'Plans', href: `${origin}/plans?jwt=${token}`, match: ['/plans'] },
      { label: 'Users', href: `${origin}/users?jwt=${token}`, match: ['/users'] },
      { label: 'Transactions', href: `${origin}/transactions?jwt=${token}`, match: ['/transactions'] },
      { label: 'Notifications', href: `${origin}/notifications?jwt=${token}&organization_id=${organizationId}`, match: ['/notifications'] },
    ]
  }

  buildMenuGroups = () => {
    const { type, token } = this.state
    const origin = document.location.origin
    const organizationId = this.state.organization_id || localStorage.getItem('organization_id') || ''
    const organizationName = encodeURIComponent(
      this.state.name || localStorage.getItem('organization_name') || ''
    )
    const registrationHref = `${origin}/enrollmentform?jwt=${token}&organization_id=${organizationId}&organization_name=${organizationName}`

    const adminGroups = [
      {
        title: 'Overview',
        items: [
          { label: 'Organization Dashboard', href: `${origin}/portals?jwt=${token}` },
          { label: 'Programs and Events', href: `${origin}/programs2?jwt=${token}` },
          { label: 'Rosters', href: `${origin}/programRosters?jwt=${token}` },
        ],
      },
      {
        title: 'Operations',
          items: [
            { label: 'Pricing and Plans', href: `${origin}/plans?jwt=${token}` },
            { label: 'Notifications', href: `${origin}/notifications?jwt=${token}&organization_id=${organizationId}` },
            { label: 'Transactions', href: `${origin}/transactions?jwt=${token}` },
            { label: 'Users', href: `${origin}/users?jwt=${token}` },
          ],
        },
      {
        title: 'Organization',
        items: [
          { label: 'Profile', href: `${origin}/organizationform?jwt=${token}` },
          { label: 'Parent Portal', href: `${origin}/portals?jwt=${token}&portalMode=parent` },
        ],
      },
    ]

    const sharedGroups = {
      coach: [
        {
          title: 'Quick Links',
          items: [
            { label: 'Parent Portal', href: `${origin}/portals?jwt=${token}&portalMode=coach` },
            { label: 'Rosters', href: `${origin}/programRosters?jwt=${token}` },
            { label: 'Logout', href: `${origin}/logout?jwt=${token}` },
          ],
        },
      ],
      parent: [
        {
          title: 'Account',
          items: [
            { label: 'Registration', href: registrationHref },
            { label: 'My teams', href: `${origin}/portals?jwt=${token}` },
            { label: 'Logout', href: `${origin}/logout?jwt=${token}` },
          ],
        },
      ],
      admin: [
        ...adminGroups,
        {
          title: 'Help',
          items: [
            { label: 'Documentation', href: 'https://docs.google.com/document/d/14vBKR3I3HI_minPS6qM14nS88_STLAHSPdc6Rtey3w4/edit?usp=sharing', target: '_blank' },
            { label: 'Logout', href: `${origin}/logout?jwt=${token}` },
          ],
        },
      ],
      manager: [
        {
          title: 'Overview',
          items: [
            { label: 'Programs and Events', href: `${origin}/programs2?jwt=${token}` },
            { label: 'Rosters', href: `${origin}/programRosters?jwt=${token}` },
          ],
        },
        {
          title: 'Operations',
          items: [
            { label: 'Pricing and Plans', href: `${origin}/plans?jwt=${token}` },
            { label: 'Notifications', href: `${origin}/notifications?jwt=${token}&organization_id=${organizationId}` },
            { label: 'Users', href: `${origin}/users?jwt=${token}` },
          ],
        },
        {
          title: 'Organization',
          items: [
            { label: 'Parent Portal', href: `${origin}/portals?jwt=${token}&portalMode=manager` },
            { label: 'Logout', href: `${origin}/logout?jwt=${token}` },
          ],
        },
      ],
    }

    return sharedGroups[type] || []
  }

  render() {
    const { type, navbarTextColor, menuOpen, viewportWidth } = this.state
    const { backHref, backLabel = 'Back' } = this.props
    const isMobile = viewportWidth < 768
    const isDesktop = !isMobile
    const currentPath = typeof document !== 'undefined' ? document.location.pathname : ''
    const desktopTabs = this.buildDesktopTabs(currentPath)
    const logoutHref = `${document.location.origin}/logout?jwt=${this.state.token}`
    const showProfileSettings = this.props.hideProfileSettings !== true && type && type !== 'parent'
    const showFamily = this.props.showFamily === true
    const familyHref = `${document.location.origin}/family?jwt=${this.state.token}${this.state.organization_id ? `&organization_id=${this.state.organization_id}` : ''}`
    const navbarStyle = {
      position: 'relative',
      backgroundColor: this.state.navbarColor,
      backgroundImage: `linear-gradient(135deg, ${this.state.navbarColor} 0%, rgba(28, 35, 40, 0.28) 100%)`,
      color: navbarTextColor
    }
    const menuGroups = type ? this.buildMenuGroups() : []
    return (
      <>
      <Navbar staticTop style={navbarStyle}>
        <div className="navbar-top-shell" style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          gap: '12px',
          minHeight: isMobile ? '64px' : '70px',
          padding: isMobile ? '0 12px' : '0 14px',
        }}>
          {isMobile ? (
            <button
              type="button"
              onClick={this.toggleMenu}
              aria-label="Open navigation menu"
              className="navbar-menu-button"
            >
              <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} size="lg" style={{ color: navbarTextColor }} />
            </button>
          ) : (
            <div className="navbar-desktop-brand">
              <div
                className="org-name"
                style={{
                  border: 'none',
                  color: navbarTextColor,
                  fontSize: '1.15rem',
                  fontWeight: 700,
                  lineHeight: 1.1,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {this.state.name}
              </div>
            </div>
          )}

          <div className="nav-image" style={{ marginLeft: isDesktop ? 'auto' : 'auto' }}>
            <div
              className="navbar-logo-dropdown-anchor"
              style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}
              onMouseEnter={isDesktop ? this.openLogoMenu : undefined}
              onMouseLeave={isDesktop ? this.scheduleCloseLogoMenu : undefined}
            >
              <div className="navbar-logo-slot" style={{ cursor: 'default', padding: 0 }}>
                {this.state.logo ? (
                  <button
                    type="button"
                    className="navbar-logo-button"
                    onClick={isMobile ? this.toggleLogoMenu : undefined}
                    aria-label="Open account menu"
                  >
                    <Image
                      src={this.state.logo}
                      className="navbar-logo-image"
                      style={{ cursor: isDesktop ? 'default' : 'pointer', objectFit: 'contain' }}
                    />
                  </button>
                ) : null}
              </div>

              {this.state.logoMenuOpen && this.state.logo && (
                <div
                  ref={this.logoMenuRef}
                  className="navbar-logo-dropdown"
                  onMouseEnter={isDesktop ? this.openLogoMenu : undefined}
                  onMouseLeave={isDesktop ? this.scheduleCloseLogoMenu : undefined}
                  style={{
                    position: 'absolute',
                    top: 'calc(100% + 10px)',
                    right: 0,
                    minWidth: '240px',
                    background: '#ffffff',
                    borderRadius: '16px',
                    boxShadow: '0 24px 60px rgba(15, 23, 42, 0.20)',
                    border: '1px solid rgba(148, 163, 184, 0.22)',
                    zIndex: 1003,
                    padding: '8px',
                  }}
                >
                  <div style={{ display: 'grid', gap: '6px' }}>
                    {showFamily && (
                      <a
                        href={familyHref}
                        onClick={this.closeLogoMenu}
                        className="navbar-logo-dropdown-item"
                      >
                        <span>Family</span>
                        <span>→</span>
                      </a>
                    )}
                    {showProfileSettings && (
                      <a
                        href={`${document.location.origin}/organizationform?jwt=${this.state.token}`}
                        onClick={this.closeLogoMenu}
                        className="navbar-logo-dropdown-item"
                      >
                        <span>Profile &amp; Settings</span>
                        <span>→</span>
                      </a>
                    )}
                    <a
                      href={logoutHref}
                      onClick={this.closeLogoMenu}
                      className="navbar-logo-dropdown-item"
                    >
                      <span>Log out</span>
                      <span>→</span>
                    </a>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {menuOpen && type && (
          <div
            onClick={this.closeMenu}
            style={{
              position: 'fixed',
              inset: 0,
              background: 'rgba(15, 23, 42, 0.42)',
              backdropFilter: 'blur(2px)',
              zIndex: 999,
            }}
          />
        )}

        {menuOpen && type && (
          <div
            ref={this.menuRef}
            style={{
              position: 'fixed',
              top: isMobile ? 0 : '72px',
              left: isMobile ? 0 : '12px',
              width: isMobile ? '100vw' : 'min(420px, calc(100vw - 24px))',
              height: isMobile ? '100vh' : 'auto',
              maxHeight: isMobile ? '100vh' : 'calc(100vh - 88px)',
              overflowY: 'auto',
              background: '#ffffff',
              borderRadius: isMobile ? 0 : '20px',
              boxShadow: '0 24px 60px rgba(15, 23, 42, 0.24)',
              border: '1px solid rgba(148, 163, 184, 0.22)',
              zIndex: 1001,
              padding: isMobile ? '18px 16px 24px' : '10px',
            }}
          >
            <div style={{ padding: '8px 10px 14px', borderBottom: '1px solid #eef2f7', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px' }}>
              <div>
                <div style={{ fontSize: '0.78rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#64748b', fontWeight: 700 }}>
                  Navigation
                </div>
                <div style={{ fontSize: '1.05rem', fontWeight: 700, color: '#0f172a', marginTop: '4px' }}>
                  {this.state.name}
                </div>
              </div>
              {isMobile && (
                <button
                  type="button"
                  onClick={this.closeMenu}
                  aria-label="Close navigation menu"
                  style={{
                    width: '42px',
                    height: '42px',
                    borderRadius: '14px',
                    border: '1px solid #e2e8f0',
                    background: '#f8fafc',
                    color: '#0f172a',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    flexShrink: 0,
                  }}
                >
                  <FontAwesomeIcon icon={faTimes} size="lg" />
                </button>
              )}
            </div>

            {menuGroups.map((group) => (
              <div key={group.title} style={{ padding: '10px 0 6px' }}>
                <div style={{ fontSize: '0.72rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#94a3b8', fontWeight: 700, padding: '4px 10px 8px' }}>
                  {group.title}
                </div>
                <div style={{ display: 'grid', gap: '6px' }}>
                  {group.items.map((item) => (
                    <a
                      key={item.label}
                      href={item.href}
                      target={item.target}
                      rel={item.target === '_blank' ? 'noopener noreferrer' : undefined}
                      onClick={this.closeMenu}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: isMobile ? '14px 14px' : '12px 14px',
                          borderRadius: '14px',
                          textDecoration: 'none',
                          color: '#0f172a',
                          background: '#f8fafc',
                          border: '1px solid #e2e8f0',
                        transition: 'transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease, background 140ms ease',
                      }}
                    >
                      <span style={{ fontWeight: 600 }}>{item.label}</span>
                      <span style={{ color: '#94a3b8', fontSize: '0.95rem' }}>→</span>
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </Navbar>

      {isDesktop && (
        <div className="navbar-desktop-row">
          {backHref && (
            <a
              className="navbar-desktop-back-button"
              href={backHref}
              aria-label={backLabel}
              title={backLabel}
            >
              <FontAwesomeIcon icon={faChevronLeft} className="navbar-desktop-back-button-icon" />
            </a>
          )}
          <div className="navbar-desktop-tabs" role="navigation" aria-label="Primary navigation">
            {type && desktopTabs.map((tab) => {
              const isActive = tab.match.some((segment) => currentPath.includes(segment))
              return (
                <a
                  key={tab.label}
                  href={tab.href}
                  className={`navbar-desktop-tab${isActive ? ' active' : ''}`}
                  aria-current={isActive ? 'page' : undefined}
                >
                  {tab.label}
                </a>
              )
            })}
          </div>
        </div>
      )}
      </>
    )
  }
}

export default HamburgerNavbar;
